import React, { useState } from "react";
import "./navbar.css";
import Modal from "../modal/Modal";
import { useNavigate } from "react-router-dom";

const Navbar = () => {
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);

  const handleClickLogo = () => {
    if (window.location.pathname !== "/") {
      setLoading(true);
      setTimeout(() => {
        setLoading(false);
        navigate("/");
      }, 500);
    }
  };
  return (
    <>
      {loading && (
        <div className="loading-gif">
          <span className="loader"></span>
        </div>
      )}
      <div className="Navbar-div sticky-top">
        <div className="Navbar">
          <button onClick={handleClickLogo} className="logo">
            Online<i className="logo-icon fa-brands fa-shopify"></i>
            <span>hop</span>
          </button>
          <Modal />
        </div>
      </div>
    </>
  );
};

export default Navbar;
